import type { SetupModalItem } from '@ruta/shared';
import { PostImportEvent, type PostImportProperties } from '../events';

export const PostImportEvents = {
  firstWeekVisible: (props: {
    org_id: string;
    role?: string;
    visits_shown_next_7d: number;
    empty_active_services: number;
  }) => ({
    event: PostImportEvent.FIRST_WEEK_VISIBLE as const,
    properties: props satisfies Partial<PostImportProperties>,
  }),

  scheduleEmptyStateShown: (props: {
    org_id: string;
    role?: string;
    service_id: string;
    service_type: string;
  }) => ({
    event: PostImportEvent.SCHEDULE_EMPTY_STATE_SHOWN as const,
    properties: props satisfies Partial<PostImportProperties>,
  }),

  setupModalShown: (props: { org_id: string; role?: string; item: SetupModalItem }) => ({
    event: PostImportEvent.SETUP_MODAL_SHOWN as const,
    properties: props satisfies Partial<PostImportProperties>,
  }),

  setupModalItemClicked: (props: { org_id: string; role?: string; item: SetupModalItem }) => ({
    event: PostImportEvent.SETUP_MODAL_ITEM_CLICKED as const,
    properties: props satisfies Partial<PostImportProperties>,
  }),

  setupModalDismissed: (props: { org_id: string; role?: string; item: SetupModalItem }) => ({
    event: PostImportEvent.SETUP_MODAL_DISMISSED as const,
    properties: props satisfies Partial<PostImportProperties>,
  }),

  setupModalCompleted: (props: { org_id: string; role?: string; item: SetupModalItem }) => ({
    event: PostImportEvent.SETUP_MODAL_COMPLETED as const,
    properties: props satisfies Partial<PostImportProperties>,
  }),
} as const;
